import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
function SmsNotification() {
    const [rowsData, setRowsData] = useState([]);
    const [sortConfig, setSortConfig] = useState({
        key: "name",
        direction: "ascending",
    });
    const [loading, setLoading] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const [searchQuery, setSearchQuery] = useState(""); // New state for search query
    const [streetName, setStreetName] = useState([]);
        const [networkName, setNetworkName] = useState([]);
    const [messageName, setMessageName] = useState([]);
  
    const [smsType, setSmsType] = useState("single");
    const [smsLanguage, setSmsLanguage] = useState("tamil");
    const [stbNumber, setStbNumber] = useState("");
    const [street, setStreet] = useState("");
        const [network, setNetwork] = useState("");
    const [date, setDate] = useState("");
    const [bulkNumbers, setBulkNumbers] = useState(""); // For bulk SMS input
    const navigate = useNavigate();
    const user = getCookie('user');
    const handleSmsTypeChange = (event) => setSmsType(event.target.value);
    const handleSmsLanguageChange = (event) => setSmsLanguage(event.target.value);
    const handleStbNumberChange = (event) => setStbNumber(event.target.value);
    const handleStreetChange = (event) => setStreet(event.target.value);
    const handleNetworkChange = (event) => setNetwork(event.target.value);
    const handleDateChange = (event) => setDate(event.target.value);
    const handleBulkNumbersChange = (event) => setBulkNumbers(event.target.value);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = messageName.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(messageName.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const [formData, setFormData] = useState({ date: "", toDate: "" })
    const initialFormData = { date: "", toDate: "" }
    const handleClear = () => { setFormData(initialFormData); };
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    function handleClick(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); handleReport();
        async function handleReport() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/messageSpecific', { user, formData });
                if (response.status === 200) {
                    console.log(response.data);
                    setMessageName(response.data.result);
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    }
    const handleSubmit = async (event) => {
        event.preventDefault();

        let formattedBulkNumbers = [];

        if (smsType === "bulk") {
            if (bulkNumbers.trim() !== "") {
                formattedBulkNumbers = bulkNumbers.split(",").map(num => num.trim());
            }
        }

        const formData = {
            smsType,
            smsLanguage,
            stbNumber: smsType === "single" ? stbNumber : "",
            street: smsType === "streetWise" ? street : "",
            network: smsType === "networkWise" ? network : "",
            date,
            bulkNumbers: formattedBulkNumbers,  // ✅ Ensuring bulkNumbers is an array
        };

        console.log("Data:", formData);

        try {
            const response = await axios.post('https://node.cabletvpay.in/smsNotification', { user, formData });
            console.log("Response:", response.data);
            alert("SMS sent successfully!");
        } catch (error) {
            console.error("Error sending SMS:", error);
            alert("Failed to send SMS.");
        }
    };


    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/messageGetInfo', { user });
            if (response.status === 200) {

                setNetworkName(response.data.networkDetails);
                setStreetName(response.data.streetDetails);
                setMessageName(response.data.messageDetails);
                console.log("result:", response.data.messageDetails);

            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };

    useEffect(() => { fetchUserData(); }, []);
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">SMS NOTIFICATION</div>
                    <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                </div>
                <hr />
                <div className="mt-3 mb-2 mb-lg-5 mx-lg-5">
                    <div className="border-0 px-1">

                        <form method="get" onSubmit={handleClick}>
                            <div className="row mx-3 d-flex justify-content-center">

                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="date" className="text-center valuesDec text-navy">From</label>
                                        <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                        <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-3 col-6 py-4 pt-1 d-flex justify-content-center">
                                    <input type="submit" className="btn border-0  bg-info filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                                </div>
                                <div className="col-lg-1 col-md-3 col-6  py-4 pt-1 d-flex justify-content-center">
                                    <button type="button" className="btn border-0 bg-danger filterBtn text-light  pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>

                <div className="mt-1 mb-2">
                    <div className="card border-0 px-1 py-3">
                        <h1 class="text-center text-bold">Send Unpaid SMS</h1>
                        <form onSubmit={handleSubmit} className="pt-4">
                            <div className="row mx-3 d-flex justify-content-center">

                                {/* SMS Type Selection */}
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label className="text-center valuesDec text-navy">Select SMS Type:</label>
                                        <select className="form-control" value={smsType} onChange={handleSmsTypeChange}>
                                            <option value="single">Default Single Unpaid SMS</option>
                                            <option value="streetWise">Default Street Wise Unpaid SMS</option>
                                              <option value="networkWise">Default Network Wise Unpaid SMS</option>
                                            <option value="bulk">Default Bulk Unpaid SMS</option>
                                        </select>
                                    </div>
                                </div>

                                {/* SMS Language Selection */}
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label className="text-center valuesDec text-navy">Select SMS Language</label>
                                        <select className="form-control" value={smsLanguage} onChange={handleSmsLanguageChange}>
                                            {/* <option value="tamil">Tamil</option> */}
                                            <option value="english">English</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Conditional Fields Based on SMS Type */}
                                {smsType === "single" && (
                                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                                        <div className="form-group">
                                            <label className="text-center valuesDec text-navy">Enter STB Number</label>
                                            <input type="text" className="form-control text-dark border-1" value={stbNumber} onChange={handleStbNumberChange} />
                                        </div>
                                    </div>
                                )}

                                {smsType === "streetWise" && (
                                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                                        <div className="form-group">
                                            <label className="text-center valuesDec text-navy">Select Street</label>
                                            <select className="form-control" value={street} onChange={handleStreetChange}>
                                                {streetName.length > 0 ? (
                                                    streetName.map((row, index) => (
                                                        <option className='bg-light' key={index} value={row.street_name}>
                                                            {row.street_name}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option className='bg-light' value="">No staff codes available</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                )}
 {smsType === "networkWise" && (
                                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                                        <div className="form-group">
                                            <label className="text-center valuesDec text-navy">Select Network</label>
                                            <select className="form-control" value={network} onChange={handleNetworkChange}>
                                                {networkName.length > 0 ? (
                                                    networkName.map((row, index) => (
                                                        <option className='bg-light' key={index} value={row.network_name}>
                                                            {row.network_name}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option className='bg-light' value="">No staff codes available</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                )}

                                {/* Reminder Date */}
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label className="text-center valuesDec text-navy">Select Reminder Date</label>
                                        <input type="date" className="form-control text-dark border-1" value={date} onChange={handleDateChange} />
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="col-lg-2 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                                    <input type="submit" className="btn border-0 bg-info filterBtn rounded text-light h-75 pb-3 w-100" value="Send SMS" />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            {/* Header Title */}
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            {/* Actions */}
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        {/* Search Bar */}
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control text-navy bg-light border-0 px-1 py-0"
                                                    placeholder="Search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ borderRadius: "5px 0 0 5px" }}
                                                />
                                                <span
                                                    className="input-group-text bg-light text-navy border-0 px-2"
                                                    id="basic-addon1"
                                                    style={{ borderRadius: "0 5px 5px 0" }}
                                                >
                                                    <i className="fas fa-search" />
                                                </span>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                        <table id="myTable" className="table table-striped bg-white table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    {/* Table headers with sorting functionality */}
                                    <th>Sl_No</th>
                                    <th>Customer Name</th>
                                    <th>STB Number</th>
                                    <th>Mobile Number</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index}>
                                                              <td className='tableText'>{indexOfFirstRow + index + 1}</td>

                                            <td>{row.cus_name}</td>
                                            <td>{row.serial_num}</td>
                                            <td>{row.mobile}</td>
                                            <td>{row.date}</td>
                                            <td>{row.time}</td>
                                            <td>{row.message}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SmsNotification;
